import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useGetCumulativeAssignmentReportMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../../../../reports/components/reportContext';
import { useSearchParams } from 'react-router-dom';

const AssignmentCumulativeReport = () => {
  const [searchParams] = useSearchParams();
  const [getCumulativeAssignmentReport] = useGetCumulativeAssignmentReportMutation();
  const reportContext = useReportContext();
  var studentToIncludeTab = parseInt(searchParams.get('studentsToInclude'));
  const isTeacherReport = !isNaN(parseInt(studentToIncludeTab, 10));

  const getReportTitle = () => {
    if (isTeacherReport && reportContext) {
      if (studentToIncludeTab == 0)
        return reportContext.isAssessment ? 'All Students- Single Assessment Report' : 'All Students- Single Assignment Report';
      else if (studentToIncludeTab == 1)
        return reportContext.isAssessment ? 'Class- Single Assessment Report' : 'Class- Single Assignment Report';
    }
    else
      return 'Cumulative Assignment Report';
  };

  var headerOptions = {
    reportTitle: getReportTitle(),
    showClassDropdown: !isTeacherReport,
    showTeacherName: true,
    showStudentName: isTeacherReport ? (studentToIncludeTab == 0 || studentToIncludeTab == 2) : false,
    showClassName: isTeacherReport ? studentToIncludeTab == 1 : true,
    isAllStudentReport: false,
    showRetryInfo: false,
    showTotalRow: true,
    showReportType: true,
    reportType: 'Assignment'
  };

  return (
    <QuestionBreakdownReport
      includeRetakeData={false}
      exportFileName='ClassCumilativeReport'
      reportDataEndpoint={getCumulativeAssignmentReport}
      isTeacherReport={isTeacherReport}
      headerOptions={headerOptions}
      studentToIncludeTab={studentToIncludeTab}
      goBackOnError={true}
    />
  );

};

export default AssignmentCumulativeReport;